import { render, staticRenderFns } from "./editWfModalComponent.vue?vue&type=template&id=492dbc8a&scoped=true&"
import script from "./editWfModalComponent.vue?vue&type=script&lang=js&"
export * from "./editWfModalComponent.vue?vue&type=script&lang=js&"
import style0 from "./editWfModalComponent.vue?vue&type=style&index=0&id=492dbc8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492dbc8a",
  null
  
)

export default component.exports